(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-header"]) return;
  try {
    
  (() => {
    if (customElements.get('predictive-search-page')) return;

    const I18N = {
      it: {
        query: 'Suggerimenti', product: 'Prodotti', collection: 'Collezioni', page: 'Pagine', article: 'Articoli',
        viewAll: 'Vedi tutti i risultati per', empty: 'Nessun risultato per', soldOut: 'Esaurito',
        count: (n) => `${n} risultati disponibili`,
      },
      fr: {
        query: 'Suggestions', product: 'Produits', collection: 'Collections', page: 'Pages', article: 'Articles',
        viewAll: 'Voir tous les résultats pour', empty: 'Aucun résultat pour', soldOut: 'Épuisé',
        count: (n) => `${n} résultats disponibles`,
      },
      en: {
        query: 'Suggestions', product: 'Products', collection: 'Collections', page: 'Pages', article: 'Articles',
        viewAll: 'View all results for', empty: 'No results for', soldOut: 'Sold out',
        count: (n) => `${n} results available`,
      },
    };

    const esc = (s) =>
      String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    const highlight = (text, q) => {
      const safe = esc(text);
      const needle = esc(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return needle ? safe.replace(new RegExp(`(${needle})`, 'ig'), '<mark>$1</mark>') : safe;
    };

    const sized = (src, w = 160) => (src ? `${src}${src.includes('?') ? '&' : '?'}width=${w}` : '');

    class PredictiveSearchPage extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;

        this.input = this.querySelector('input[type="search"], input[name="q"]');
        this.results = this.querySelector('[data-ps-results]');
        this.status = this.querySelector('[data-ps-status]');
        if (!this.input || !this.results) return;

        const lang = (this.dataset.locale || 'en').slice(0, 2).toLowerCase();
        this.t = I18N[lang] || I18N.en;
        this.cache = new Map();
        this.activeIndex = -1;
        this.min = parseInt(this.dataset.minChars, 10) || 2;

        this.money = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        });

        Object.entries({
          autocomplete: 'off',
          role: 'combobox',
          'aria-autocomplete': 'list',
          'aria-controls': this.results.id,
          'aria-expanded': 'false',
        }).forEach(([k, v]) => this.input.setAttribute(k, v));

        let timer;
        this.onInput = () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.search(), 250);
        };
        this.onKeydown = (e) => this.handleKey(e);
        this.onFocus = () => {
          if (this.results.innerHTML && this.input.value.trim().length >= this.min) this.open();
        };
        this.onDocClick = (e) => {
          if (!this.contains(e.target)) this.close();
        };
        this.onResize = () => {
          if (!this.results.hidden) this.position();
        };

        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('keydown', this.onKeydown);
        this.input.addEventListener('focus', this.onFocus);
        document.addEventListener('click', this.onDocClick);
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (!this.input) return;
        this.input.removeEventListener('input', this.onInput);
        this.input.removeEventListener('keydown', this.onKeydown);
        this.input.removeEventListener('focus', this.onFocus);
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('resize', this.onResize);
      }

      async search() {
        const q = this.input.value.trim();
        if (q.length < this.min) {
          this.results.innerHTML = '';
          this.close();
          return;
        }
        if (this.cache.has(q)) return this.render(q, this.cache.get(q));

        this.controller?.abort();
        this.controller = new AbortController();

        const params = new URLSearchParams({
          q,
          'resources[type]': this.dataset.types || 'product',
          'resources[limit]': this.dataset.limit || '4',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': this.dataset.unavailable || 'last',
          'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor,tag',
        });

        this.setAttribute('loading', '');
        try {
          const res = await fetch(`${this.dataset.url}.json?${params}`, {
            signal: this.controller.signal,
            headers: { Accept: 'application/json' },
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const data = await res.json();
          const results = data?.resources?.results || {};
          this.cache.set(q, results);
          if (this.input.value.trim() === q) this.render(q, results);
        } catch (err) {
          if (err.name !== 'AbortError') console.error('[predictive-search]', err);
        } finally {
          this.removeAttribute('loading');
        }
      }

      row(url, inner) {
        return `<li class="ps__item" role="option" aria-selected="false"><a href="${esc(url)}" tabindex="-1">${inner}</a></li>`;
      }

      thumb(src, alt) {
        return src
          ? `<img src="${esc(sized(src))}" alt="${esc(alt)}" width="56" height="56" loading="lazy">`
          : '<span class="ps__ph" aria-hidden="true"></span>';
      }

      group(key, rows) {
        return rows.length
          ? `<div class="ps__group"><p class="ps__heading">${this.t[key]}</p><ul class="ps__list" role="presentation">${rows.join('')}</ul></div>`
          : '';
      }

      price(p) {
        const n = parseFloat(p);
        return Number.isFinite(n) ? this.money.format(n) : '';
      }

      render(q, r) {
        const showPrice = this.dataset.showPrice === 'true';
        const showVendor = this.dataset.showVendor === 'true';

        const html = [
          this.group(
            'query',
            (r.queries || []).map((x) =>
              this.row(x.url, `<span class="ps__text"><span class="ps__title">${highlight(x.text, q)}</span></span>`)
            )
          ),
          this.group(
            'product',
            (r.products || []).map((x) => {
              const meta = [
                showVendor && x.vendor ? esc(x.vendor) : '',
                showPrice ? (x.available === false ? this.t.soldOut : this.price(x.price)) : '',
              ]
                .filter(Boolean)
                .join(' · ');
              return this.row(
                x.url,
                `${this.thumb(x.featured_image?.url || x.image, x.featured_image?.alt || x.title)}
                 <span class="ps__text"><span class="ps__title">${highlight(x.title, q)}</span>${
                   meta ? `<span class="ps__meta">${meta}</span>` : ''
                 }</span>`
              );
            })
          ),
          this.group(
            'collection',
            (r.collections || []).map((x) =>
              this.row(
                x.url,
                `${this.thumb(x.featured_image?.url, x.title)}<span class="ps__text"><span class="ps__title">${highlight(x.title, q)}</span></span>`
              )
            )
          ),
          this.group(
            'page',
            (r.pages || []).map((x) =>
              this.row(x.url, `<span class="ps__text"><span class="ps__title">${highlight(x.title, q)}</span></span>`)
            )
          ),
          this.group(
            'article',
            (r.articles || []).map((x) =>
              this.row(
                x.url,
                `${this.thumb(x.featured_image?.url || x.image, x.title)}<span class="ps__text"><span class="ps__title">${highlight(x.title, q)}</span></span>`
              )
            )
          ),
        ].join('');

        const allUrl = `${this.dataset.searchUrl}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
        const footer = `<div class="ps__group"><ul class="ps__list" role="presentation">${this.row(
          allUrl,
          `<span>${this.t.viewAll} «${esc(q)}»</span><span aria-hidden="true">→</span>`
        ).replace('ps__item', 'ps__item ps__all')}</ul></div>`;

        this.results.innerHTML = html
          ? html + footer
          : `<p class="ps__empty">${this.t.empty} «${esc(q)}»</p>`;

        this.options = [...this.results.querySelectorAll('[role="option"]')];
        this.options.forEach((el, i) => (el.id = `${this.results.id}-opt-${i}`));
        this.activeIndex = -1;
        this.input.removeAttribute('aria-activedescendant');
        if (this.status) this.status.textContent = this.t.count(Math.max(this.options.length - (html ? 1 : 0), 0));
        this.open();
      }

      position() {
        const host = this.getBoundingClientRect();
        const anchor = (this.input.closest('form') || this.input).getBoundingClientRect();
        this.results.style.top = `${anchor.bottom - host.top + 8}px`;
        this.results.style.left = `${Math.max(anchor.left - host.left, 0)}px`;
        this.results.style.width = `${Math.min(anchor.width, host.width)}px`;
      }

      open() {
        this.position();
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (!this.results) return;
        this.results.hidden = true;
        this.input?.setAttribute('aria-expanded', 'false');
        this.input?.removeAttribute('aria-activedescendant');
        this.setActive(-1);
      }

      setActive(i) {
        (this.options || []).forEach((el, idx) => el.setAttribute('aria-selected', String(idx === i)));
        this.activeIndex = i;
        const el = this.options?.[i];
        if (el) {
          this.input.setAttribute('aria-activedescendant', el.id);
          el.scrollIntoView({ block: 'nearest' });
        }
      }

      handleKey(e) {
        if (this.results.hidden || !this.options?.length) return;
        const last = this.options.length - 1;

        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            this.setActive(this.activeIndex >= last ? 0 : this.activeIndex + 1);
            break;
          case 'ArrowUp':
            e.preventDefault();
            this.setActive(this.activeIndex <= 0 ? last : this.activeIndex - 1);
            break;
          case 'Enter':
            if (this.activeIndex >= 0) {
              e.preventDefault();
              this.options[this.activeIndex].querySelector('a')?.click();
            }
            break;
          case 'Escape':
            this.close();
            break;
        }
      }
    }

    customElements.define('predictive-search-page', PredictiveSearchPage);
  })();

  } catch(e) { console.error(e); }
})();
})();
